import { useState } from 'react';
import { Trans } from '@lingui/macro';
import { Button } from '@material-ui/core';

import DeleteDialog from './DeleteDialog';

export default function ConfirmDeleteButton({ handleConfirmedDelete, disabled = false, plural = false, label }) {
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const theLabel = label || <Trans>Delete</Trans>;

    const handleRequestedDelete = () => {
        setShowConfirmationDialog(true);
    };

    return (
        <>
            <Button onClick={handleRequestedDelete} disabled={disabled}>
                {theLabel}
            </Button>
            <DeleteDialog
                plural={plural}
                open={showConfirmationDialog}
                setOpen={setShowConfirmationDialog}
                onConfirm={handleConfirmedDelete}
            />
        </>
    );
}
